module.exports = "{{full_name}} <span class=\"text--grey\">{{login}}</span>\n"